import {
  RATIO_1_1,
  WIDTH_200,
  WIDTH_400,
} from '../constants/imageServiceConstants';

const getImageUrl = (images) => {
  const key = images?.file_names[0];
  if (!key) { return ''; }
  const oneToOneImages = images.urls[key][RATIO_1_1];
  return oneToOneImages[WIDTH_400] || oneToOneImages[WIDTH_200];
};

export default getImageUrl;
